import { render, staticRenderFns } from "./auth-required.vue?vue&type=template&id=72aef044&scoped=true&"
import script from "./auth-required.vue?vue&type=script&lang=js&"
export * from "./auth-required.vue?vue&type=script&lang=js&"
import style0 from "./auth-required.vue?vue&type=style&index=0&id=72aef044&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aef044",
  null
  
)

export default component.exports